import React from 'react';
import BundleOverviewControllerTab from '../BundleOverviewControllerTab/BundleOverviewControllerTab';
import BundleOverviewControllerGa2Tab from '../BundleOverviewControllerGa2Tab/BundleOverviewControllerGa2Tab';

const BundleOverviewControllerDUTab = ({ isGa2, deviceType, ...rest }) => {
  if (!['pivot', 'echo'].includes(deviceType)) {
    return null;
  }

  // Extract API version from device properties if available
  const device = rest.device || {};
  let ga2ApiVersion = 'v1'; // Default to v1
  
  if (device?.properties?.reported) {
    ga2ApiVersion = device.properties.reported['ga2-ibms-api-version'] || 'v1';
  }

  if (isGa2) {
    return <BundleOverviewControllerGa2Tab 
      isGa2={isGa2} 
      deviceType={deviceType} 
      ga2ApiVersion={ga2ApiVersion} 
      {...rest} 
    />;
  }

  return <BundleOverviewControllerTab deviceType={deviceType} {...rest} />;
};

export default BundleOverviewControllerDUTab;
